import { useState } from 'react'
import { generate } from 'generate-password-browser';
import { resetClientPassword, sendClientCredentaials } from '../../utilities/api/clients';
import './ResetClientPassword.css'
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import { formNotificationStyle2 } from '../../utilities/services/formNotification';


export default function ResetClientPassword({user, client, toggleNotifications}) {
    const passwordLength = 12
    const [receiverEmail, setReceiverEmail] = useState('')
    const [passwordResetFormData, setPasswordResetFormData] = useState({
        newPassword: '',
        confirmPassword: '',
    })
    const [newPassword, setNewPassword] = useState('')
    const [showSendCredentialsForm, setShowSendCredentialsForm] = useState(false)

    function handleResetPasswordChange(evt) {
        const newFormData = {
            ...passwordResetFormData,
            [evt.target.name]: evt.target.value,
        };
        setPasswordResetFormData(newFormData)
    }

    const generatePassword = () => {
          const password = generate({
              length: passwordLength,
              numbers: true,
          });
          setPasswordResetFormData((prevData) => ({
            ...prevData,
            newPassword: password,
            confirmPassword: password,
          }));
          formNotificationStyle2('clientCreationNotification', 'New Password Generated!', '#0A7637', 0.8 )
    }

    const handleResetClientPassword =async (evt) => {
        evt.preventDefault()
        const data = {
          currentUserID: user._id,
          client: client,
          newPassword: passwordResetFormData.newPassword,
        }
        setShowSendCredentialsForm(false)
        try {
          const response = await resetClientPassword(client._id, data)
          if (response.status === 'success') {
            toggleNotifications('success', `${response.msg}`, '#FFFFFF')
            // console.log(response)
            setNewPassword(passwordResetFormData.newPassword)
            setPasswordResetFormData({
                newPassword: '',
                confirmPassword: '',
            })
            setShowSendCredentialsForm(true)
          } else {
            toggleNotifications('error', `${response.msg}`, '#FFFFFF')
          }
        } catch (error) {
          toggleNotifications('error', `${error.message}`, '#FFFFFF')
        }
        
    }

    const sendLoginCredentials = async (evt) => {
        evt.preventDefault()
        try {
            await sendClientCredentaials(client._id, {email: receiverEmail.trim(), clientPassword: newPassword})
            await toggleNotifications('success', `Credentials sent to '${receiverEmail}'`)
        } catch (error) {
            console.log(error)
            await toggleNotifications('error', `Unable to send credentials to '${receiverEmail}'`)
        }
    }

    const updateReceiverEmail = (evt) => {
        setReceiverEmail(evt.target.value)
    }

    const disabled = passwordResetFormData.newPassword === '' || passwordResetFormData.newPassword.length < 5 || passwordResetFormData.confirmPassword === '' || passwordResetFormData.newPassword !== passwordResetFormData.confirmPassword

  return (
    <div className='ResetClientPassword modal fade ResetClientPasswordModal' id='resetClientPasswordModal' data-bs-keyboard="false" aria-labelledby={`ResetClientPasswordHeader`}>
        <div className='modal-dialog modal-dialog-centered'>
            <div className='modal-content'>
                <div className='modal-header'>
                    <div className='headerContent'>
                        <svg width="30" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.875 12.375V7.875C7.875 6.38316 8.46763 4.95242 9.52252 3.89752C10.5774 2.84263 12.0082 2.25 13.5 2.25C14.9918 2.25 16.4226 2.84263 17.4775 3.89752C18.5324 4.95242 19.125 6.38316 19.125 7.875V12.375M5.625 12.375H21.375C22.6176 12.375 23.625 13.3824 23.625 14.625V22.5C23.625 23.7426 22.6176 24.75 21.375 24.75H5.625C4.38236 24.75 3.375 23.7426 3.375 22.5V14.625C3.375 13.3824 4.38236 12.375 5.625 12.375Z" stroke="#344054" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <div>
                            <div className='firstHeader'>Reset Password</div>
                            <div className='secondHeader'>{capitalizeFirstLetter(client.companyName)}</div>
                        </div>
                    </div>
                    <div className='right'>
                        <svg data-bs-dismiss="modal" width="25" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16.2666" cy="16.2666" r="15.7666" fill="#EDEFF2" stroke="#EEEEEE"/>
                        <path d="M21.1093 12L12 21.1093M12 12L21.1093 21.1093" stroke="#1B2B41" strokeOpacity="0.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div className='modal-body'>
                    <div className='itemContainer'>
                        <form onSubmit={handleResetClientPassword} id={`resetClientPassword`}>
                            <div className='formContent mb-2'>
                                <div className=''>
                                    <label htmlFor={`newPassword`}>New Password</label>
                                    <input className='form-control' type="text" name="newPassword" id={`newPassword`} placeholder='Enter New Password' value={passwordResetFormData.newPassword} onChange={handleResetPasswordChange} required autoComplete='off'/>
                                </div>
                                { (passwordResetFormData.newPassword && passwordResetFormData.newPassword.length < passwordLength) && 
                                <small className="errorText">&nbsp;Must be at least {passwordLength} characters long!</small>
                                }
                                <div className='mt-3'>
                                    <label htmlFor={`confirmPassword`}>Confirm Password</label>
                                    <input className='form-control' type="text" name="confirmPassword" id={`confirmPassword`} placeholder='Enter Confirm Password' value={passwordResetFormData.confirmPassword} onChange={handleResetPasswordChange} required autoComplete='off' />
                                </div>
                                { (passwordResetFormData.newPassword && passwordResetFormData.confirmPassword && (passwordResetFormData.newPassword !== passwordResetFormData.confirmPassword)) && 
                                <small className="errorText">&nbsp;Passwords do not match!</small>
                                }
                            </div>
                            <button type='button' className='generatePassword' onClick={generatePassword}>
                                Generate Password
                            </button>
                            <div className='modalButtonContainer mt-3'>
                                <button data-bs-dismiss="modal" type='button' className='cancel'>Cancel</button>
                                <button className="primary submit" form="resetClientPassword" type="submit" disabled={disabled}>Change Password</button>
                            </div>
                        </form>
                    </div>
                    { showSendCredentialsForm &&
                    <>
                        <div className='resetSuccessMessage'>
                            <div className='title'>Password reset successfully!</div>
                            <div className='subtitle'>You can now send the new credentials to the client.</div>
                        </div>
                        <div className='itemContainer p-0 ps-3 pe-3'>
                            <div className='item'>
                                <svg width="35" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="22" cy="22" r="22" fill="#1A5E9B" fillOpacity="0.1"/>
                                    <path d="M30.6667 16.6667C30.6667 15.75 29.9167 15 29 15H15.6667C14.75 15 14 15.75 14 16.6667M30.6667 16.6667V26.6667C30.6667 27.5833 29.9167 28.3333 29 28.3333H15.6667C14.75 28.3333 14 27.5833 14 26.6667V16.6667M30.6667 16.6667L22.3333 22.5L14 16.6667" stroke="#1A5E9B" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <div className='itemContent'>
                                    <div className='label'>
                                        User ID
                                    </div>
                                    {client.companyEmail}
                                </div>
                            </div>
                            <div className='item'>
                                <svg width="35" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="22" cy="22" r="22" fill="#1A5E9B" fillOpacity="0.1"/>
                                    <path d="M25.0435 20.0435V16.2199C25.0435 15.3659 24.6724 14.5469 24.012 13.9431C23.3515 13.3392 22.4558 13 21.5217 13C20.5877 13 19.6919 13.3392 19.0315 13.9431C18.371 14.5469 18 15.3659 18 16.2199V20.0435" stroke="#1A5E9B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M26.3087 20.0439H16.9957C15.8935 20.0439 15 20.9096 15 21.9774V29.067C15 30.1348 15.8935 31.0005 16.9957 31.0005H26.3087C27.4109 31.0005 28.3043 30.1348 28.3043 29.067V21.9774C28.3043 20.9096 27.4109 20.0439 26.3087 20.0439Z" stroke="#1A5E9B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <div className='itemContent'>
                                    <div className='label'>
                                        Password
                                    </div>
                                    {newPassword}
                                </div>
                            </div>
                        </div>
                        <form className='sendCredentialsForm' id='sendCredentialsForm' title='Send Login Credentials to Client' onSubmit={sendLoginCredentials}>
                            <label htmlFor="receiverEmail">Receiver's Email</label>
                            <input className='form-control' type="email" name="receiverEmail" id="receiverEmail" placeholder="Enter Receiver's Email" defaultValue={receiverEmail} onChange={updateReceiverEmail}/>
                        </form>
                        <div className='modalButtonContainer'>
                            <button data-bs-dismiss="modal" type='button' className='cancel'>Cancel</button>
                            <button data-bs-dismiss="modal" className="primary sendCredentialsButton" type="submit" form='sendCredentialsForm'>Send Credentials</button>
                        </div>
                        <div className='ms-3' id='sentCredentialsNotification'></div>
                    </>
                    }
                </div>
                
                
            </div>
        </div>
    </div>
  )
}
